import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getAllCertifications = async () => {
  const res = await axios.apiCadernoVirtual(
    "/certification-service/certification",
    {}
  );
  return res.object;
};

export const useAllCertifications = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["allCertifications"],
    queryFn: getAllCertifications,
  });
};
